<template>
    <div class="container">
        <form>
            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label" for="id_message">Text to Analyze</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <textarea id="id_message" v-model="message" class="textarea is-primary"
                                      placeholder="Enter your text here..."></textarea>
                        </div>
                    </div>
                </div>
            </div>
            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label" for="id_filtered_words">Filtered Words</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <input class="input" type="text" id="id_filtered_words" v-model="filtered_words">
                        </div>
                    </div>
                </div>
            </div>
            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label" for="id_min_word_length">Minimum Word Length</label>
                </div>
                <div class="field-body has-text-left">
                    <div class="field">
                        <div class="control">
                            <div class="select">
                                <select id="id_min_word_length" v-model="min_word_length">
                                    <option>1</option>
                                    <option>2</option>
                                    <option>3</option>
                                    <option>4</option>
                                    <option>5</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label" for="id_use_similarity_analysis">Similarity Analysis (Slow)</label>
                </div>
                <div class="field-body has-text-left">
                    <div class="field">
                        <div class="control">
                            <input type="checkbox" id="id_use_similarity_analysis" v-model="use_similarity_analysis">
                        </div>
                    </div>
                </div>
            </div>
            <div class="field is-grouped is-grouped-right">
                <p class="control">
                    <a class="button is-primary" @click="analyze()">
                        Analyze!
                    </a>
                </p>
            </div>
        </form>
        <div class="content has-text-left"  v-show="results_available && wordcloud_available">
            <p>
                <a @click="toggleWordCloudVisibility()" v-show="!wordcloud_visible">[+ Show]</a>
                <a @click="toggleWordCloudVisibility()" v-show="wordcloud_visible">[- Hide]</a>
                &bull; <a @click="downloadWordCloud()">[Download]</a> &bull;
                Word Cloud</p>
            <div class="content" id="svg-content" v-show="wordcloud_visible"></div>
        </div>
        <div class="content" v-if="results_available">
            <hr/>
            <div class="content has-text-left" v-if="context_available">
                <div class="columns">
                    <div class="column is-three-quarters">
                    <p>
                        <a @click="hideContext()">[- Hide]</a> &bull;
                        Context for
                        <strong>{{context_key}}</strong>
                        <em> (count: {{context_count}})</em>
                        <span v-if="context_variations.length > 0">
                            (variations:
                                <span><a @click="showContextForString(context_variations[0])">{{context_variations[0]}}</a></span>
                                <span v-for="(item, index) in context_variations.slice(1)" :key="index">, <a @click="showContextForString(item)">{{item}}</a></span>)
                        </span>
                    </p>
                    <ul>
                        <li v-for="(item, index) in context" :key="index">
                            <span v-html="$options.filters.highlightify(item, context_key)"></span>
                        </li>
                    </ul>
                    </div>
                    <div class="column" v-if="context_whatelse_wordcount.length > 0">
                        <p>
                            Top words within the context
                        </p>
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>{{columns[0]}}</th>
                                    <th v-for="(column, index) in columns.slice(1)" :key="index"> {{column}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in context_whatelse_wordcount" :key="index">
                                    <td>{{item[columns[0]]}}</td>
                                    <td v-for="(column, indexColumn) in columns.slice(1)" :key="indexColumn">
                                        {{item[column]}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <div class="container">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>{{columns[0]}}</th>
                                    <th v-for="(column, index) in columns.slice(1)" :key="index"> {{column}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in counts.filter(el => el.count > Math.min(1, counts[0].count - 1))" :key="index"
                                    v-bind:class="{ 'has-text-weight-bold': context_available && context_key === item[columns[0]] }">
                                    <td><a @click="showContext(counts, index)">{{item[columns[0]]}}</a></td>
                                    <td v-for="(column, indexColumn) in columns.slice(1)" :key="indexColumn">
                                        {{item[column]}}
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-if="wordcount_tail_available">
                                <tr>
                                    <td>
                                        <a @click="toggleWordCountTailVisibility()" v-show="!wordcount_tail_visible">[+ Show]</a>
                                        <a @click="toggleWordCountTailVisibility()" v-show="wordcount_tail_visible">[- Hide]</a>
                                        More
                                    </td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </tbody>
                            <tbody v-if="wordcount_tail_available" v-show="wordcount_tail_visible">
                                <tr v-for="(item, index) in counts.filter(el => el.count <= Math.min(1, counts[0].count - 1))" :key="index"
                                    v-bind:class="{ 'has-text-weight-bold': context_available && context_key === item[columns[0]] }">
                                    <td><a @click="showContextForString(item.word)">{{item[columns[0]]}}</a></td>
                                    <td v-for="(column, indexColumn) in columns.slice(1)" :key="indexColumn">
                                        {{item[column]}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="column" v-for="(pkey, index) in ['phrase2', 'phrase3', 'phrase4', 'tuple2']" :key="index">
                    <div class="container">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>{{pkey}}</th>
                                    <th v-for="(column, index) in phrase_columns.slice(1)" :key="index"> {{column}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in phrase_counts[pkey]" :key="index"
                                    v-bind:class="{ 'has-text-weight-bold': context_available && context_key === item[phrase_columns[0]] }">
                                    <td><a @click="showContext(phrase_counts[pkey], index)">{{item[phrase_columns[0]]}}</a>
                                    </td>
                                    <td v-for="(column, indexColumn) in phrase_columns.slice(1)" :key="indexColumn">
                                        {{item[column]}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="content has-text-left" v-if="similarities_available">
                <hr/>
                <p v-if="similarities_computing">Finding similar lines ...</p>
                <div class="content" v-if="!similarities_computing">
                    <p>Found <strong>{{similar_sentences_count}}</strong> similarities.</p>
                    <ul>
                        <li v-for="(item, index) in similarities" :key="index">
                            {{ sentences[item.i] }}
                            <ul>
                                <li v-for="(jitem, jindex) in item.similarSentencesToI" :key="jindex">
                                    {{sentences[jitem.j]}} (Score: {{jitem.score}})
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="content has-text-left" v-if="sentiments_available">
                <hr/>
                <p v-if="sentiments_computing">Analyzing sentiments...</p>
                <div class="content" v-for="(skey, sindex) in [['positive', sentiments_positive], ['negative', sentiments_negative]]" :key="sindex">
                    <div class="content" v-if="!sentiments_computing">
                        <p>Identified <strong>{{skey[1].length}}</strong> {{skey[0]}} sentiments:</p>
                        <ul>
                            <li v-for="(item, index) in skey[1]" :key="index">
                                {{ sentences[item.i] }} (Score: {{item.score}})
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // similarity analysis
    const use = require('@tensorflow-models/universal-sentence-encoder');
    const tf = require('@tensorflow/tfjs');

    // sentiment analysis
    const sentiment_model = sentimentLoadModelAndMetadata();

    // wordcloud
    const d3 = require('d3');
    const d3cloud = require('d3-cloud');
    const svg2png = require('save-svg-as-png');

    // stemmer
    const stemmer = require('stemmer');

    function dictKeyIncrCount(dict, key, context) {
        let keydata = dict[key] || {count: 0, context: new Set()};

        // For the same line, count the word only once.
        if (!keydata.context.has(context)) {
            keydata.count = keydata.count + 1;
            keydata.context.add(context);
            dict[key] = keydata;
            return 1;
        } else {
            return  0;
        }
    }

    function dictKeysIncrCount(dict, keys, context) {
        let keydata;
        let totalcount = 0;

        for (const key of keys) {
            keydata = dict[key] || {count: 0, context: new Set()};
            // For the same line, count phrase only once.
            if (!keydata.context.has(context)) {
                keydata.count = keydata.count + 1;
                keydata.context.add(context);
                dict[key] = keydata;
                totalcount++;
            }
        }

        return totalcount;
    }

    // Phrase = consecutive words
    function listPhrases(words, phrase_length) {
        console.assert(phrase_length > 0);

        const result = [];
        for (let i = 0; i <= words.length - phrase_length; i++) {
            let phrase = words.slice(i, i + phrase_length);
            phrase = phrase.join(' ');
            result.push(phrase);
        }

        return result;
    }

    // Tuple = any combination of words
    function listTuples(words, tuple_length, filtered_words, min_word_length) {
      // TODO: Support tuples other than pairs.
      console.assert(tuple_length === 2);

      // TODO: Stop-copying re around.
      const re = /[\w'’]+/gmu;
      let filtered_words_list = filtered_words.match(re);

      const result = [];
      for (let i = 0; i < words.length; i++) {
        if (words[i].length < min_word_length) {
          continue;
        }
        if (filtered_words_list.includes(words[i])) {
          continue;
        }

        for (let j = i + 1; j < words.length; j++) {
          if (words[j].length < min_word_length) {
            continue;
          }
          if (filtered_words_list.includes(words[j])) {
            continue;
          }
          if (words[j] === words[i]) {
            continue;
          }

          // TODO: Stem or not to stem?
          // let tuple = [stemmer(words[i]), stemmer(words[j])];
          let tuple = [words[i], words[j]];

          tuple.sort();

          // TODO: -Use "&" to join as a HACK. Otherwise context_key (which needs to be unique
          // get mixed with 2 word phrases. (ex: don't know as a tuple2 and phrase2)
          // - double hack Use "&" to detect this is a tuple for highlightify.
          // - triple hack: context_whatelse_wordcount works correctly because regexes drop '&' as context is added to
          // the filtered words.
          tuple = tuple.join(' & ');
          result.push(tuple);
        }
      }

      return result;
    }

    function dictToSortedArray(counts, min_count, total_count) {
        console.assert(min_count > 0);

        if (total_count === 0) {
          console.assert(Object.keys(counts).length === 0)
          return [];
        }
        console.assert(total_count > 0);

        const counts_a = [];
        for (const key in counts) {
            const item = {
                word: key,
                phrase: key,
                count: counts[key].count,
                context: counts[key].context,
                frequency: ((counts[key].count * 100) / total_count).toFixed(2) + '%'
            };

            if (counts[key].count >= min_count) {
                counts_a.push(item)
            }
        }

        counts_a.sort((a, b) => {
            let result = b.count - a.count;
            if (result === 0) {
                if (a.word < b.word) {
                    result = -1
                } else if (a.word > b.word) {
                    result = 1
                }
            }
            return result;
        });
        return counts_a;
    }

    function phrasecount(sentences, filtered_words, min_word_length) {
        // TODO: Stop-copying re around.
        const re = /[\w'’]+/gmu;

        const phrase2 = {};
        const phrase3 = {};
        const phrase4 = {};
        const tuple2 = {};

        let total_count2 = 0;
        let total_count3 = 0;
        let total_count4 = 0;
        let total_count_tuple2 = 0

        for (const sentencei in sentences) {
            const sentence = sentences[sentencei];
            const words = sentence.match(re);
            if (words) {
                total_count2 += dictKeysIncrCount(phrase2, listPhrases(words, 2), sentencei);
                total_count3 += dictKeysIncrCount(phrase3, listPhrases(words, 3), sentencei);
                total_count4 += dictKeysIncrCount(phrase4, listPhrases(words, 4), sentencei);

                total_count_tuple2 += dictKeysIncrCount(tuple2, listTuples(words, 2, filtered_words, min_word_length), sentencei);
            }
        }

        return {
            'phrase2': dictToSortedArray(phrase2, 2, total_count2),
            'phrase3': dictToSortedArray(phrase3, 2, total_count3),
            'phrase4': dictToSortedArray(phrase4, 2, total_count4),
            'tuple2': dictToSortedArray(tuple2, 2, total_count_tuple2),
        }
    }

    function wordcount(sentences, filtered_words, min_word_length, min_count) {
        // TODO: Stop-copying re around.
        const re = /[\w'’]+/gmu;
        let filtered_words_list = filtered_words.match(re);

        if (filtered_words_list == null) {
            filtered_words_list = []
        }

        const counts = {};
        let total_count = 0;

        const variations = {};

        for (const [sentencei, sentence] of sentences.entries()) {
            const words = sentence.match(re);
            if (words) {
                for (const word of words) {
                    if (word.length < min_word_length) {
                        continue;
                    }
                    if (filtered_words_list.includes(word)) {
                        continue;
                    }

                    const stem = stemmer(word);
                    const stemset = variations[stem] || new Set();
                    stemset.add(word);
                    variations[stem] = stemset;

                    total_count += dictKeyIncrCount(counts, word, sentencei);
                }
            }
        }

        const sorted_array = dictToSortedArray(counts, min_count, total_count);

        // Add stem based variations.
        for (const item of sorted_array) {
            const stemset = variations[stemmer(item.word)];
            if (stemset.size > 1) {
                const itemstemset = new Set(stemset);
                itemstemset.delete(item.word);
                item['variations'] = Array.from(itemstemset);
            }
        }

        return sorted_array;
    }

    // Sentiment Analysis:
    // Reference: https://github.com/tensorflow/tfjs-examples/tree/master/sentiment

    let sentimentModel = null;
    let sentimentMetadata = null;

    const SENTIMENT_PAD_INDEX = 0;  // Index of the padding character.
    const SENTIMENT_OOV_INDEX = 2;  // Index fo the OOV character.

    async function sentimentLoadModelAndMetadata() {
        // TODO: Model is not a great match.
        // Original location: https://storage.googleapis.com/tfjs-models/tfjs/sentiment_cnn_v1/model.json
        const modelUrl = '/sentiment_cnn_v1/model.json';
        const metadataUrl = '/sentiment_cnn_v1/metadata.json';

        try {
            if (!sentimentModel) {
                sentimentModel = await tf.loadLayersModel(modelUrl);
            }
            if (!sentimentMetadata) {
                const metadataJson = await fetch(metadataUrl);
                sentimentMetadata = await metadataJson.json();
            }
            return null;
        } catch (err) {
            console.error("Error while loading sentiment data : "  + err);
            return err;
        }
    }

    /**
     * Pad and truncate all sequences to the same length
     *
     * @param {number[][]} sequences The sequences represented as an array of array
     *   of numbers.
     * @param {number} maxLen Maximum length. Sequences longer than `maxLen` will be
     *   truncated. Sequences shorter than `maxLen` will be padded.
     * @param {'pre'|'post'} padding Padding type.
     * @param {'pre'|'post'} truncating Truncation type.
     * @param {number} value Padding value.
     */
    function sentimentPadSequences(
        sequences, maxLen, padding = 'pre', truncating = 'pre', value = SENTIMENT_PAD_INDEX) {
        return sequences.map(seq => {
            // Perform truncation.
            if (seq.length > maxLen) {
                if (truncating === 'pre') {
                    seq.splice(0, seq.length - maxLen);
                } else {
                    seq.splice(maxLen, seq.length - maxLen);
                }
            }

            // Perform padding.
            if (seq.length < maxLen) {
                const pad = [];
                for (let i = 0; i < maxLen - seq.length; ++i) {
                    pad.push(value);
                }
                if (padding === 'pre') {
                    seq = pad.concat(seq);
                } else {
                    seq = seq.concat(pad);
                }
            }

            return seq;
        });
    }

    function sentimentSentenceToPaddedSequence(sentence) {
        // TODO: Move constants out?
        const wordIndex = sentimentMetadata['word_index'];
        const indexFrom = sentimentMetadata['index_from'];
        const vocabularySize = sentimentMetadata['vocabulary_size'];
        const maxLen = sentimentMetadata['max_len'];

        // Convert to lower case and remove all punctuations.
        const words =
            sentence.trim().toLowerCase().replace(/[.,!;:]/g, '').split(' ');

        // Convert the words to a sequence of word indices.
        const sequence = words.map(word => {
            let index = wordIndex[word] + indexFrom;
            if (index > vocabularySize) {
                index = SENTIMENT_OOV_INDEX;
            }
            return index;
        });

        return sentimentPadSequences([sequence], maxLen);
    }

    function sentimentPredict(sentences) {
        // TODO: Move constants out?
        const maxLen = sentimentMetadata['max_len'];

        if (!sentences || sentences.length === 0) {
            return [];
        }

        let inputArray = [];
        for (const sentence of sentences) {
            const paddedSequence = sentimentSentenceToPaddedSequence(sentence);
            inputArray.push(...paddedSequence);
        }

        const input = tf.tensor2d(inputArray, [sentences.length, maxLen]);

        const predictOut = sentimentModel.predict(input);
        const scores = predictOut.dataSync();
        predictOut.dispose();
        return scores;
    }

    function sentimentGetSentiments(sentences, data) {
        data.sentiments_available = true;
        data.sentiments_computing = true;
        data.sentiments_identified_count = 0;

        sentiment_model.then((err) => {
            const t0 = performance.now();

            if (!err) {
                const sentiment_scores = sentimentPredict(sentences);

                if (sentiment_scores.length > 0) {

                    const index_and_score = [];
                    for (let i = 0; i < sentences.length; i++) {
                        index_and_score[i] = {'i': i, 'score': sentiment_scores[i].toFixed(2)};
                    }

                    const index_and_score_length_filtered = index_and_score.filter(item => sentences[item.i].replace(/[.,!;:]/g, '').split(' ').length >= 3);

                    const index_and_score_positive = index_and_score_length_filtered.filter(item => item.score > 0.8).sort((a, b) => {return b.score - a.score});
                    const index_and_score_negative = index_and_score_length_filtered.filter(item => item.score < 0.2).sort((a, b) => {return a.score - b.score});

                    data.sentiments_positive = index_and_score_positive;
                    data.sentiments_negative = index_and_score_negative;
                    data.sentiments_identified_count = index_and_score_positive.length + index_and_score_negative.length;
                }
            }

            const t1 = performance.now();
            console.log("Sentiments took " + (t1 - t0) + " milliseconds.");

            data.sentiments_computing = false;
        })
        .catch((error) => {
            console.error("Promise failed sentimentGetSentiments() - load with error: " + error);
        });
    }

    function findsimilarities(sentences, data, retry=0) {

        if (retry > 1) {
          return;
        } else if (retry > 0) {
          console.log("Retrying findsimilarities(). Retry attempt: " + retry);
        }

        data.similarities_computing = true;
        data.similarities_available = true;

        use.load().then((model) => {
            const t0 = performance.now();
            const similarSentences = [];
            let similarSentencesCount = 0;

            model.embed(sentences).then((embeddings) => {
                // TODO: Leaking memory. Improve this by: https://www.tensorflow.org/js/guide/tensors_operations#memory
                // console.log(tf.memory());

                let scores = null;
                tf.tidy(() => {
                    // Note: Datasync could be improved. Tried this by: https://meowni.ca/posts/on-tfjs-datasync/
                    // --> Does not work. Same perf and responsiveness.
                    scores = embeddings.matMul((embeddings.transpose())).arraySync();
                });

                let skipSet = new Set();

                for (let i = 0; i < sentences.length; i++) {
                    if (skipSet.has(i)) {
                        continue;
                    } else if (sentences[i].trim().length === 0) {
                        skipSet.add(i);
                        continue
                    }

                    const similarSentencesToI = [];

                    for (let j = i + 1; j < sentences.length; j++) {
                        if (skipSet.has(j)) {
                            continue;
                        } else if (sentences[j].trim().length === 0) {
                            skipSet.add(j);
                            continue
                        }

                        const score = scores[i][j];

                        if (score > 0.65) {
                            // console.log(sentences[i] + ' -- ' + sentences[j] + ' :: ' + score);
                            similarSentencesToI.push({'score': score.toFixed(2), 'j': j});
                            similarSentencesCount++;

                            if (score > 0.95) {
                                skipSet.add(j);
                            }
                        }
                    }

                    if (similarSentencesToI.length > 0) {
                        similarSentencesToI.sort((a, b) => {
                            return b.score - a.score;
                        });

                        similarSentences.push({'i': i, 'similarSentencesToI': similarSentencesToI});
                    }
                }

                embeddings.dispose();

                const t1 = performance.now();
                console.log("Similarities took " + (t1 - t0) + " milliseconds.");

                data.similar_sentences_count = similarSentencesCount;
                data.similarities = similarSentences;
                data.similarities_computing = false;
            })
            .catch((error) => {
                console.error("Promise failed findsimilarities() - embed with error: " + error);
                findsimilarities(sentences, data, retry + 1);
            });
        })
        .catch((error) =>
        {
            console.error("Promise failed findsimilarities() - load with error: " + error);
            findsimilarities(sentences, data, retry + 1);
        });
    }

    function wordcloud(word_counts, data) {
        if (!word_counts || word_counts.length === 0) {
            return
        }

        const t0 = performance.now();

        const fill = d3.scaleOrdinal(d3.schemeBlues[9].slice(-6)); // 9 blue colors, pick last 6. First 3 are too faded.
        // fill = d3.scaleOrdinal(d3.schemeTableau10); // nice for colors.
        // fill = d3.scaleOrdinal(d3.schemeCategory10); // 10 pastel colors. too pastel?

        const w = 828 /*512 * 1.618*/, h = 512,
            maxFont = 96,
            maxSize = word_counts[0].count || 1,
            sizeOffset = maxFont / maxSize;

        // Process words, and limit to a max number of words.
        const ilen = Math.min(word_counts.length, 250);
        let words = [];
        for (let i = 0; i < ilen; i++) {

            if (maxSize > 1 && word_counts[i].count <= 1) {
                // If there are some words with count > 1 => stop at words with 1 count.
                break;
            }

            words.push({
                text: word_counts[i].word,
                size: word_counts[i].count,
                index: i
            });
        }

        const layout = d3cloud()
            .size([w, h])
            .words(words)
            .spiral('archimedean')
            .rotate(function () {
                // Note: Do not use random to be able re-create same svg for the same input.
                // We can hash on word length, index, count etc. but other randomness still exists in the layout.

                // return (~~(Math.random() * 5) * 30) - 60; // 5 options: -60, -30, 0, 30, 60
                return ~~(Math.random() * 2) * 90 - 30; // 2 options -30 or 60
            })
            .padding(3)
            .font("Impact")
            .fontSize(function (d) {
                return Math.max(20, Math.min(d.size * sizeOffset, maxFont));
            });

        layout.on("end", words => {
            d3.select("#svg-content").select("svg").remove();
            d3.select("#svg-content").append("svg")
                .attr('id', 'svg-element')
                .attr("width", layout.size()[0])
                .attr("height", layout.size()[1])
                .append("g")
                .attr("transform", "translate(" + layout.size()[0] / 2 + "," + layout.size()[1] / 2 + ")")
                .selectAll("text")
                .data(words)
                .enter().append("text")
                .style("font-size", function(d) { return d.size + "px"; })
                .style("fill", function (d, i) { return fill(i); })
                .style("font-family", "Impact")
                .attr("text-anchor", "middle")
                .attr("transform", function(d) {
                    return "translate(" + [d.x, d.y] + ")rotate(" + d.rotate + ")";
                })
                .text(function(d) { return d.text; });

            const t1 = performance.now();
            console.log("Wordcloud took " + (t1 - t0) + " milliseconds.");

            data.wordcloud_available = true;
        });

        layout.start();
    }

    export default {
        name: "TextAnalyzer",
        filters: {
            highlightify(value, boldkey) {
                if (!value || value.length === 0) {
                    return value;
                }

                // TODO: hack for tuples. Assumptions:
                // '&' is filtered otherwise from normal user input.
                // tuples cannot have repeated words.
                if (boldkey.includes('&')) {
                  let tuple_keys = boldkey.split(' & ');
                  let tuple_buffer = value;
                  for (const key of tuple_keys.values()) {
                    tuple_buffer = this.highlightify(tuple_buffer, key)
                  }
                  return tuple_buffer;
                }

                // Continue with word and phrase highlighting.
                const lowercase_value = value.toLowerCase();
                let start = 0;
                let end = 0;
                let buffer = "";

                while (start < lowercase_value.length) {
                    end = lowercase_value.indexOf(boldkey, start);
                    if (end === -1) {
                        buffer += value.slice(start);
                        start = lowercase_value.length;
                    } else {
                        buffer +=
                            value.slice(start, end) + // start should be updated to end after this line.
                            '<span class="has-background-warning">' +
                                value.slice(end, end + boldkey.length) +
                            '</span>';
                        start = end + boldkey.length;
                    }
                }

                return buffer;
            }
        },
        methods: {
            analyze() {
                this.results_available = false;
                this.context_available = false;
                this.similarities_available = false;
                this.sentiments_available = false;
                this.wordcloud_available = false;
                this.wordcloud_visible = false;
                this.wordcount_tail_available = false;
                this.wordcount_tail_visible = false;

                const t0 = performance.now();

                if (!this.message) {
                    return;
                }

                this.sentences = this.message.split('\n');
                const sentences_lowercase = this.message.toLowerCase().split('\n');

                this.saved_filtered_words = this.filtered_words.toLowerCase();
                this.saved_min_word_length = this.min_word_length;

                this.counts = wordcount(sentences_lowercase, this.saved_filtered_words, this.saved_min_word_length, 1);
                this.phrase_counts = phrasecount(sentences_lowercase, this.saved_filtered_words, this.saved_min_word_length);

                this.counts_reverse_index = {};
                for (const index in this.counts) {
                    this.counts_reverse_index[this.counts[index].word] = index;
                }

                this.wordcount_tail_available = (this.counts.length > 0 && this.counts[0].count > 1);

                const t1 = performance.now();
                console.log("Analyze took " + (t1 - t0) + " milliseconds.");

                if (this.use_similarity_analysis) {
                    findsimilarities(sentences_lowercase, this); // async
                }

                wordcloud(this.counts, this); // async

                sentimentGetSentiments(this.sentences, this); // async

                this.results_available = true;
            },
            showContextForString(word) {
                // TODO: Hack: Only works for single word count and not for phrases
                //  => Assume variations only apply in case of counts dictionary.
                //  => Assume hide below 1 only apply in case of counts dictionary.
                this.showContext(this.counts, this.counts_reverse_index[word]);
            },
            showContext(arr, index) {
                const contextSet = arr[index].context;
                const contextKey = arr[index].word;

                // toggle off for the same key.
                if (this.context_available && this.context_key === contextKey) {
                    this.context_available = false;
                    return;
                }

                this.context_available = false;

                // Find related sentences
                const result = [];
                for (const sentenceIndex of contextSet) {
                    result.push(this.sentences[sentenceIndex])
                }

                // Do a what else wordcount
                const sentences_lowercase = result.join('\n').toLowerCase().split('\n');
                const saved_filtered_words = this.saved_filtered_words + ' ' + contextKey.toLowerCase();
                const whatelse_wordcount = wordcount(sentences_lowercase, saved_filtered_words, this.saved_min_word_length, 2);

                const item = arr[index];

                this.context_key = item.word; // should be same as contextKey
                this.context_count = item.count;
                this.context_variations = item.variations || this.emptyList;
                this.context_whatelse_wordcount = whatelse_wordcount;
                this.context = result;
                this.context_available = true;
            },
            hideContext() {
                this.context_available = false;
            },
            toggleWordCountTailVisibility() {
                this.wordcount_tail_visible = !this.wordcount_tail_visible;
            },
            toggleWordCloudVisibility() {
                this.wordcloud_visible = !this.wordcloud_visible;
            },
            downloadWordCloud() {
                // Note: Maybe use a vue related way to get the element by id, instead of using document. Not needed.
                svg2png.saveSvgAsPng(document.getElementById("svg-element"), "wordcloud_by_textclue.png");
            }
        },
        data: function () {
            const emptyList = [];

            return {
                // Form Fields
                filtered_words: 'a, all, an, and, but, does, for, has, i, not, one, that, the, this, to, too, use, with',
                min_word_length: 3,
                use_similarity_analysis: false,

                // Saved form fields, to be re-used for second level analysis. ("what else?")
                saved_filtered_words: '',
                saved_min_word_length: 0,

                //message: 'test  the one one three four five four \n four four four one two     three   four test Test',
                message: '',

                // Computed
                results_available: false,

                // Word Count
                counts: [{word: 'abc', count: 1, frequency: 5}],
                columns: ['word', 'count', 'frequency'],
                counts_reverse_index: {'abc': 0},
                wordcount_tail_available: false,  // There is at least 1 word with count > 1.
                wordcount_tail_visible: false,    // UI expand/collapse visibility.

                // Phrase Counts
                phrase_counts: {
                    'phrase2': [],
                    'phrase3': [],
                    'phrase4': [],
                    'tuple2': [],
                },
                phrase_columns: ['phrase', 'count', 'frequency'],

                // Ordered sentences. Used for similarities and context.
                sentences: [],

                // Context related
                context_available: false,
                context_key: '',
                context_count: 0,
                context_variations: emptyList,
                context_whatelse_wordcount: emptyList,
                emptyList: emptyList,
                context: [],

                // Similarities related
                similarities_available: false,
                similarities_computing: false,
                similar_sentences_count: 0,
                similarities: [],

                // Sentiment related
                sentiments_available: false,
                sentiments_computing: false,
                sentiments_identified_count: 0,
                sentiments_positive: [],
                sentiments_negative: [],

                // Word cloud related.
                wordcloud_available: false,
                wordcloud_visible: false,
            }
        },
    }
</script>

<style scoped>

</style>